var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"active"},[_c('base-card',{attrs:{"listTitle":this.listTitle,"listContent":this.listContent,"listUrl":this.listUrl,"total":this.total},on:{"currentPageChange":_vm.handlePageChange}}),_vm._v(" "),_c('base-box',{key:this.reRenderKey,attrs:{"article":this.article}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29abb711","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/active.vue
// module id = null
// module chunks = 